import React from "react";
import { Link } from "react-router-dom";

const BlogCard = ({ blogItem }) => {
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const displayCategories = blogItem?.blogCategory
    ? blogItem?.blogCategory.split(",").slice(0, 1).join(", ")
    : blogItem?.blogCategory;

  return (
    <Link
      className="blog-card"
      to={`/blogs/${blogItem.blogUrl}-${blogItem.id}`}
      target="_blank"
    >
      <div className="image">
        <img src={blogItem.thumbImage} alt="" />
      </div>
      <span className="blog-badge">{displayCategories}</span>
      <h3>{blogItem.blogName}</h3>
      <div className="posted-date">{formatDate(blogItem.postedOn)}</div>
    </Link>
  );
};

export default BlogCard;
